// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/canadian-airport-chart.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/canadian-airport-chart/canadian-airport-chart.js';

mount([g0]);
